import { SmsPreference } from './sms-preference.page';

export { SmsPreference };
